<mat-card class="custom-card" appearance="outlined">
  <div
    class="custom-card-header d-flex align-items-center justify-content-center"
  >
    <mat-card-title>{{ nombrePersona }}</mat-card-title>
  </div>

  <mat-card-content>
    <!-- Documentos Generales -->
    <div *ngIf="generales.length > 0">
      <div class="mb-2 fw-semibold text-muted">Documentos Generales</div>
      <div class="document-item mb-2 p-2 rounded" *ngFor="let doc of generales">
        <ng-container
          *ngTemplateOutlet="itemDoc; context: { doc: doc }"
        ></ng-container>
      </div>
    </div>

    <!-- Documentos Específicos -->
    <div *ngIf="especificos.length > 0" class="mt-3">
      <div class="mb-2 fw-semibold text-muted">Documentos Específicos</div>
      <div
        class="document-item mb-2 p-2 rounded"
        *ngFor="let doc of especificos"
      >
        <ng-container
          *ngTemplateOutlet="itemDoc; context: { doc: doc }"
        ></ng-container>
      </div>
    </div>

    <!-- Template documento -->
    <ng-template #itemDoc let-doc="doc">
      <div class="fw-semibold">
        {{ doc.nombre }}
        <span *ngIf="doc.obligatorio" class="text-danger">*</span>
      </div>

      <div *ngIf="doc.archivo || doc.rutaArchivo" class="text-muted small">
        {{ doc.archivo?.name || getFileName(doc.rutaArchivo) }}
      </div>

      <div class="d-flex justify-content-end gap-1 mt-2">
        <button
          mat-icon-button
          color="primary"
          matTooltip="Adjuntar archivo"
          (click)="fileInput.click()"
        >
          <mat-icon>upload_file</mat-icon>
        </button>

        <button
          mat-icon-button
          color="accent"
          matTooltip="Visualizar archivo"
          [disabled]="!doc.archivo && !doc.cargado"
          (click)="visualizeFile(doc)"
        >
          <mat-icon>open_in_new</mat-icon>
        </button>

        <button
          mat-icon-button
          color="warn"
          matTooltip="Eliminar archivo"
          [disabled]="!doc.archivo && !doc.cargado"
          (click)="deleteFile(doc, fileInput)"
        >
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>

      <input
        type="file"
        hidden
        #fileInput
        (change)="onFileSelected($event, doc, fileInput)"
      />
    </ng-template>

    <!-- Estado -->
    <div class="text-center mt-3">
      <div
        class="estado d-inline-flex align-items-center justify-content-center gap-1 px-2 py-1"
        [class.completo]="isCompleted()"
        [class.incompleto]="!isCompleted()"
      >
        <mat-icon class="estado-icon">
          {{ isCompleted() ? "check_circle" : "cancel" }}
        </mat-icon>
        <span class="estado-text">
          {{ isCompleted() ? "Completado" : "Incompleto" }}
        </span>
      </div>
    </div>
  </mat-card-content>
</mat-card>
